import { EDIT_LANG } from "../types";

const handlers = {
    [EDIT_LANG]: (state, {lang}) => ({...state, lang}),
    DEFAULT: state => state
}

export const LanguageReducer = (state, action) => {
    const handler = handlers[action.type] || handlers.DEFAULT;
    return handler(state, action);
}